<!-- <div
  class="v-input v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
> -->
<!-- <div class="v-input__control"> -->
  <div class="v-input__slot">
    <input
      style="margin: 0px"
      [name]="name"
      [type]="inputState.isShow ? 'text' : 'password'"
      (blur)="blur()"
      (focus)="focus()"
      [(ngModel)]="password"
      ng-reflect-model=""
      class="ng-untouched ng-pristine ng-valid"
      id="password"
    />
    <div class="">
      <div id="toggleConfirmPassword" class="v-input__icon v-input__icon--append">
        <app-mdi-eye
          [show]="inputState.isShow"
          (click)="inputState.isShow = !inputState.isShow"
        ></app-mdi-eye>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <!-- </div> -->
  